import Util from "../../utils/Util"

/**
 * Represents an AttributeValue of the the AttributeValueInterface from expivi
 *
 * @see attribute_values property of the AttributeInterface from expivi
 */
export default class AttributeValue {
    constructor(data) {
        this.data = data
    }

    /**
     * Non-Static check for nested properties on the data object.
     *
     * @param key
     * @returns {boolean}
     */
    has(key) {
        return Util.hasNestedProperty(this.data, key)
    }

    /**
     * Returns a value by key. The key may be nested using . Notation.
     *
     * @param key
     * @param defaultValue
     * @returns {boolean|*}
     */
    get(key, defaultValue = null) {
        return Util.getNestedProperty(this.data, key, defaultValue)
    }

    /**
     * Returns the ID of the attribute value
     *
     * @returns {boolean|*}
     */
    getId() {
        return this.get('id');
    }

    getAttributeId() {
        return this.get('attribute_id')
    }

    /**
     * Returns the name of the attribute value
     *
     * @returns {boolean|*}
     */
    getName() {
        return this.get('name')
    }

    /**
     * Returns weather this attribute value is selected by default
     *
     * @returns {boolean|*}
     */
    isDefault() {
        return this.get('default', false)
    }

    /**
     * Returns weather the attribute value is visible or not
     *
     * @returns {boolean|*}
     */
    isVisible() {
        return this.get('visible', false)
    }

    /**
     * Checks if a thumbnail url exists
     */
    hasThumbnailUrl() {
        return this.has('thumbnail_url')
    }

    /**
     * Returns the thumbnail url
     *
     * @returns {boolean|*}
     */
    getThumbnailUrl() {
        return this.get('thumbnail_url')
    }

    /**
     * Returns the attribute value's price
     *
     * @returns {boolean|*}
     */
    getPrice() {
        return this.get('price', 0.0)
    }

    /**
     * Returns the valuable object
     *
     * @returns {boolean|*}
     */
    getValuable() {
        return this.get('valuable')
    }

    /**
     * Returns the attribute_value_valuable property
     *
     * @returns {boolean|*}
     */
    getAttributeValueValuable() {
        return this.get('attribute_value_valuable')
    }

    getValuableId() {
        return this.get('valuable_id')
    }

    /**
     * Returns the hash of the attribute value
     *
     * @returns {boolean|*}
     */
    getHash() {
        return this.get('hash')
    }

    getDescription() {
        return this.get('description')
    }
}
